<!-- <div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">404</h1>
        <h3 class="text-uppercase error-subtitle">PÁGINA NO ENCONTRADA</h3>
        <p class="text-muted mt-4 mb-4">
            Parece que estás tratando de encontrar el camino a casa.
        </p>
        <a class="error-btn" (click)="goHome()">
            Regresar
        </a>

    </div>
</div> -->

<div class="error-box">
  <div class="error-overlay"></div>

  <div class="error-layout">
    <div class="error-image" aria-hidden="true"></div>

    <div class="error-body text-center">
      <h1 class="error-title text-danger">404</h1>
      <h3 class="text-uppercase error-subtitle">PÁGINA NO ENCONTRADA !</h3>
      <p class="error-text">PARECE QUE ESTÁS TRATANDO DE ENCONTRAR EL CAMINO A CASA</p>

        <a class="error-btn" (click)="goHome()">
            Regresar
        </a>
    </div>
  </div>
</div>
